document.addEventListener('DOMContentLoaded', function () {
  const initDrawers = (el) => {
    const siteOverflowClass = 'util-SiteOverflow';

    const elements = {
      triggers: document.querySelectorAll('[data-drawer-trigger]'),
      triggersChild: document.querySelectorAll('[data-drawer-trigger-child]'),
      triggersGrandchild: document.querySelectorAll('[data-drawer-trigger-grandchild]'),
      navigationChild: document.querySelectorAll('[data-drawer-navigation-child]'),
      navigationGrandchild: document.querySelectorAll('[data-drawer-navigation-grandchild]'),
      mask: el.querySelector('[data-drawer-mask]'),
      closeButtons: el.querySelectorAll('[data-drawer-close]'),
      drawers: document.querySelectorAll('[data-drawer-id]'),
      backChild: document.querySelectorAll('[data-drawer-back-child]'),
      backGrandchild: document.querySelectorAll('[data-drawer-back-grandchild]'),
    };

    elements.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        document.body.classList.add(siteOverflowClass);
        el.classList.add('drw-Drawers-active');
        const id = trigger.dataset.drawerTrigger;
        const target = document.querySelector(`[data-drawer-id="${id}"]`);
        if (target) {
          target.classList.add('drw-Drawer-active');
        }
      });
    });

    elements.triggersChild.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const sibling = trigger.nextElementSibling;
        if (sibling) {
          sibling.classList.toggle('drw-Drawer-childactive');
        }
      });
    });

    elements.triggersGrandchild.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const sibling = trigger.nextElementSibling;
        if (sibling) {
          sibling.classList.toggle('drw-Drawer-grandchildactive');
        }
      });
    });

    const closeAllDrawers = () => {
      document.body.classList.remove(siteOverflowClass);
      el.classList.remove('drw-Drawers-active');

      elements.navigationChild.forEach((el) => {
        el.classList.remove('drw-Drawer-childactive');
      });

      elements.navigationGrandchild.forEach((el) => {
        el.classList.remove('drw-Drawer-grandchildactive');
      });

      elements.drawers.forEach((drawer) => {
        drawer.classList.remove('drw-Drawer-active');
      });
    };

    if (elements.mask) {
      elements.mask.addEventListener('click', closeAllDrawers);
    }

    elements.closeButtons.forEach((button) => {
      button.addEventListener('click', closeAllDrawers);
    });

    elements.backChild.forEach((button) => {
      button.addEventListener('click', () => {
        const parent = button.closest('.drw-Drawer-childactive');
        if (parent) {
          parent.classList.remove('drw-Drawer-childactive');
        }
      });
    });

    elements.backGrandchild.forEach((button) => {
      button.addEventListener('click', () => {
        const parent = button.closest('.drw-Drawer-grandchildactive');
        if (parent) {
          parent.classList.remove('drw-Drawer-grandchildactive');
        }
      });
    });
  };

  // Target the `.drw-Drawers` element directly
  const drawersContainer = document.querySelector('.drw-Drawers');
  if (drawersContainer) {
    initDrawers(drawersContainer);
  }
});
